import { useEffect, useState } from "react";

type HealthState = "checking" | "online" | "offline";

export default function ApiHealthChip() {
  const [state, setState] = useState<HealthState>("checking");

  useEffect(() => {
    let cancelled = false;
    async function probe() {
      try {
        const res = await fetch("/health", { method: "GET", cache: "no-store" });
        if (!cancelled) setState(res.ok ? "online" : "offline");
      } catch {
        if (!cancelled) setState("offline");
      }
    }
    void probe();
    const id = window.setInterval(probe, 30_000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  const label = state === "checking" ? "CHECKING" : state === "online" ? "ONLINE" : "OFFLINE";
  const cls =
    state === "online"
      ? "server-status-chip online"
      : state === "offline"
        ? "server-status-chip offline"
        : "server-status-chip checking";

  return (
    <span className={cls} role="status" aria-live="polite">
      {label}
    </span>
  );
}
